export default __webpack_public_path__ + "static/media/SpeedBumpCropped.c76c5205.jpg";